'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromBot = undefined;

var _isSenderType = require('./isSenderType');

var _senderTypes = require('../constants/senderTypes');

var isFromBot = exports.isFromBot = (0, _isSenderType.isSenderType)(_senderTypes.BOT);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isFromBot.js
// module id = 112
// module chunks = 2 3